import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { AuthenticationService } from 'src/app/services/auth-service/authentication.service';
import { TokenStorageService } from 'src/app/services/token-storage-service/token-storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', Validators.required),
  });

  public user: any;
  isLoggedIn = false;

  visibile = false;
  changeType = true;

  constructor(
    public router: Router,
    private authService: AuthenticationService,
    private toast: HotToastService,
    private tokenStorageService: TokenStorageService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.tokenStorageService.getToken() !== '';
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();

      if (this.user.role !== 'admin') {
        this.tokenStorageService.signOut();
      }

      this.router.navigateByUrl('/');
    }
  }

  viewPassword() {
    this.visibile = !this.visibile;
    this.changeType = !this.changeType;
  }

  get email() {
    return this.loginForm.get('email');
  }

  get password() {
    return this.loginForm.get('password');
  }

  submitLoginForm() {
    if (!this.loginForm.valid) {
      return;
    }

    const { email, password } = this.loginForm.value;

    this.authService
      .loginFirebase(email, password)
      .then((user) => {
        this.authService.login(user._tokenResponse.idToken).subscribe(
          async (data) => {
            if (data.user.role == 'admin') {
              this.tokenStorageService.saveToken(data.token);
              this.tokenStorageService.saveRefreshToken(data.refreshToken);
              this.tokenStorageService.saveUser(data.user);

              window.location.reload();
            } else {
              this.toast.error('Unauthorized');
            }
          },
          (error) => {
            this.toast.error('An error occurred');
          }
        );
      })
      .catch((error) => {
        switch (error.message) {
          case 'Firebase: Error (auth/user-not-found).':
          case 'Firebase: Error (auth/wrong-password).':
            this.toast.error('Incorrect email or password.');
            break;
          case 'Firebase: Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later. (auth/too-many-requests).':
            this.toast.error('Too many atempts. Please try again later.');
            break;
          default:
            this.toast.error('An error occurred');
            break;
        }
      });
  }
}
